import { useEffect, useState, type ReactNode, type ComponentType } from "react";
import PageTitle from "../PageTitle";

interface PageLayoutProps {
  title: string;
  children: ReactNode;
  StyledComponent: ComponentType<any>;
  containerClassName?: string;
  wrapInContainer?: boolean;
  onBack?: () => void;
}

const PageLayout = ({
  title,
  children,
  StyledComponent,
  containerClassName = "page-container",
  wrapInContainer = true,
  onBack,
}: PageLayoutProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <StyledComponent $isVisible={isVisible}>
      <PageTitle title={title} onBack={onBack} />
      {wrapInContainer ? (
        <div className={containerClassName}>{children}</div>
      ) : (
        children
      )}
    </StyledComponent>
  );
};

export default PageLayout;
